<template>
    <div class="w-100">
        <p class="statistical-title d-none d-lg-block">THỐNG KÊ</p>
        <div
            class="statistical-container d-flex align-items-center justify-content-between"
        >
            <label>Số kỳ quay</label>
            <Select
                v-model="selectedTurnsDisplay"
                :options="turns"
                id="display"
                class="statistical__select-channel"
            />
            <Button
                value="Xem"
                @click="clickSearchNumberTime"
                theme="dark"
                variant="secondary"
                class="w-100 btn-custom"
            />
        </div>
        <transition name="fade" mode="out-in">
            <Spinner v-if="loading" />
            <div class="w-100" v-else>
                <template v-if="appearData && appearData.length > 0">
                    <p
                        v-if="appearData.length > 0"
                        class="statistical__has-found"
                    >
                        Đã tìm thấy kết quả trong
                        {{ this.selectedTurns.value }} kỳ quay
                    </p>
                    <p v-else>
                        Không tìm thấy kết quả trong
                        {{ this.selectedTurns.value }} kỳ quay
                    </p>

                    <p class="statistical-title">
                        10 Cặp số xuất hiện nhiều nhất trong
                        {{ this.selectedTurns.value }} kỳ gần nhất
                    </p>
                    <table
                        v-if="appearData.length > 0"
                        class="w-100 statistical-table"
                    >
                        <tbody>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(0)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(0)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(1)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(1)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(2)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(2)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(3)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(3)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(4)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(4)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(5)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(5)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(6)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(6)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(7)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(7)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(8)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(8)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="checkValueOccurrences(9)"
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >xuất hiện
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumberOccurrences(9)
                                            }}</span
                                        >
                                        lần</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="statistical-title statistical-title-second">
                        10 Cặp số đã lâu không ra
                    </p>
                    <table class="w-100 statistical-table">
                        <tbody>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 1)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 1,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 2)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 2,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 3)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 3,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 4)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 4,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                            </tr>

                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 5)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 5,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 6)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 6,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 7)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 7,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 8)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 8,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(notAppearData.length - 9)
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 9,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                                <td class="w-12">
                                    <CircleNumber
                                        :number-input="
                                            checkValue(
                                                notAppearData.length - 10,
                                            )
                                        "
                                    />
                                </td>
                                <td class="w-38">
                                    <span
                                        class="statistical-table__display-number"
                                        >không ra
                                        <span
                                            class="statistical-table__sub-display-number"
                                            >{{
                                                checkNumber(
                                                    notAppearData.length - 10,
                                                )
                                            }}</span
                                        >
                                        kỳ</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <span v-else>Có lỗi xãy ra vui lòng kiểm tra lại</span>
            </div>
        </transition>
    </div>
</template>

<script>
import Button from '@/components/common/Button/Button';
import Select from '@/components/common/Select/Select';
import CircleNumber from '@/components/common/CircleNumber/CircleNumber';
import Spinner from '@/components/common/Spinner/Spinner';

export default {
    components: {
        Button,
        Select,
        CircleNumber,
        Spinner,
    },
    props: {
        appearData: Array,
        notAppearData: Array,
        city: {
            type: Number,
            require: false,
            default: 1,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        selectedDate: {
            type: String,
            require: false,
        },
        numberTurn: {
            type: String,
            require: false,
        },
    },
    data() {
        return {
            search: null,
            searchNumber: null,
            hasFound: false,
            turns: [
                { name: '5', value: '5' },
                { name: '10', value: '10' },
                { name: '20', value: '20' },
                { name: '30', value: '30' },
                { name: '40', value: '40' },
                { name: '50', value: '50' },
            ],
            selectedTurns: {},
            selectedTurnsDisplay: { name: '10', value: '10' },
        };
    },

    methods: {
        clickSearchNumberTime() {
            this.selectedTurns = this.selectedTurnsDisplay;
            this.$emit('search-number-time', this.selectedTurns.value);
        },

        checkValue(index) {
            return this.notAppearData[index] &&
                this.notAppearData[index].value.toString()
                ? this.notAppearData[index].value
                : '';
        },

        checkNumber(index) {
            return this.notAppearData[index] && this.notAppearData[index].number
                ? (
                      Number(this.selectedTurns.value) -
                      Number(this.notAppearData[index].number)
                  ).toString()
                : '';
        },

        checkValueOccurrences(index) {
            return this.appearData[index] &&
                this.appearData[index].value.toString()
                ? this.appearData[index].value
                : '';
        },

        checkNumberOccurrences(index) {
            return this.appearData[index] && this.appearData[index].number
                ? this.appearData[index].number.toString()
                : '';
        },
    },
    created() {
        this.selectedTurns = this.turns.find(v => {
            return v.value === this.numberTurn;
        });
        this.selectedTurnsDisplay = this.selectedTurns;
    },
    watch: {
        numberTurn: function(newVal, oldVal) {
            if (newVal && oldVal && newVal !== oldVal) {
                this.selectedTurns = this.turns.find(v => {
                    return v.value === this.numberTurn;
                });
                this.selectedTurnsDisplay = this.selectedTurns;
            }
        },
        selectedDate: function(newVal, oldVal) {
            if (newVal && oldVal && newVal !== oldVal) {
                this.selectedTurns = this.turns.find(v => {
                    return v.value === this.numberTurn;
                });
                this.selectedTurnsDisplay = this.selectedTurns;
            }
        },
        city: function(newVal, oldVal) {
            if (newVal && oldVal && newVal !== oldVal) {
                this.selectedTurns = this.turns.find(v => {
                    return v.value === this.numberTurn;
                });
                this.selectedTurnsDisplay = this.selectedTurns;
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import './StatisticalTable.scss';
</style>
